import { useEffect, useRef } from 'react';
export function createElementObject(instance, context, container) {
  return Object.freeze({
    instance: instance,
    context: context,
    container: container
  });
}
export function createElementHook(createElement, updateElement) {
  if (updateElement == null) {
    return function useImmutableLeafletElement(props, context) {
      var elementRef = useRef();
      if (!elementRef.current) elementRef.current = createElement(props, context);
      return elementRef;
    };
  }
  return function useMutableLeafletElement(props, context) {
    var elementRef = useRef();
    if (!elementRef.current) elementRef.current = createElement(props, context);
    var propsRef = useRef(props);
    var instance = elementRef.current.instance;
    useEffect(function updateElementProps() {
      if (propsRef.current !== props) {
        updateElement(instance, props, propsRef.current);
        propsRef.current = props;
      }
    }, [instance, props, context]);
    return elementRef;
  };
}